import { render, staticRenderFns } from "./productDetailView.vue?vue&type=template&id=71143846&scoped=true"
import script from "./productDetailView.vue?vue&type=script&lang=js"
export * from "./productDetailView.vue?vue&type=script&lang=js"
import style0 from "./productDetailView.vue?vue&type=style&index=0&id=71143846&prod&scoped=true&lang=css"
import style1 from "./productDetailView.vue?vue&type=style&index=1&id=71143846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71143846",
  null
  
)

export default component.exports